import { createReducer } from '@reduxjs/toolkit';
import { toLower } from 'lodash';

import { addPartnerTaskTags, removePartnerTaskTags, setPartnerTaskTagsLoading, updatePartnerTaskTags } from 'data/actions/taskTags';
import { TagData } from 'data/models/TaskTags';

interface State {
  isLoading: boolean;
  tags: Array<TagData>;
}

const initialState: State = {
  tags: [],
  isLoading: false,
};

export default createReducer(initialState, builder => {
  builder.addCase(setPartnerTaskTagsLoading, (state, action) => {
    state.isLoading = action.payload;
  });

  builder.addCase(updatePartnerTaskTags, (state, action) => {
    if (!action.payload) return state;
    state.tags = action.payload.sort((a, b) => toLower(a.key).localeCompare(toLower(b.key)));
  });

  builder.addCase(addPartnerTaskTags, (state, action) => {
    if (!action.payload) return state;
    state.tags = [...state.tags, action.payload].sort((a, b) => toLower(a.key).localeCompare(toLower(b.key)));
  });

  builder.addCase(removePartnerTaskTags, (state, action) => {
    if (!action.payload) return state;
    state.tags = state.tags.filter(tag => tag.id !== action.payload);
  });
});
